export default __webpack_public_path__ + "static/media/bannerGuardiao.b9eab17a.jpg";